import { VersioningStatusEnum } from '@/enums/VersioningStatus';
import { GradeEnum } from './ScheduledLessonReport';

export enum MGActivityTypeEnum {
  HOMEWORK = 'HOMEWORK',
}

export interface MGActivity {
  id: number;
  status: VersioningStatusEnum;
  unit: number | null;
  name: string;
  isActive: true;
  activityAuthor: number;
  activityType: MGActivityTypeEnum;
}

export interface MGActivityProgress {
  id: number;
  activity: MGActivity;
  startDate: string;
  lastUpdate: string;
  hasDone: boolean;
  grade: GradeEnum | null;
  comment: string | null;
}
